import * as members from '../../privates/privateMembers';
import isAllowedComponentAPI from '../../privates/utils/componentAPISupport';

class AnimatableMixin {
    get isAnimatable() {
        const type = members._type.get(this);
        const {viewerType, compType} = type;
        return compType !== 'Gallery' || isAllowedComponentAPI(viewerType, 'animate');
    }
}

export default AnimatableMixin;
